import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { AgGridReact } from "ag-grid-react";
import {
  SELECTED_ICON,
  updateNavigationState,
} from "../../helpers/reducers/NavigationReducer";
import {
  SELECTED_CHECKLIST,
  updateGlobalState,
} from "../../helpers/reducers/GlobalReducer";
import {
  agGridOptionsNone,
  agGridTheme,
} from "../../helpers/constants/Constants";

const ChecklistSidePanel = () => {
  const { selectedObjectData } = useSelector((state) => state.modelReducer);
  const dispatch = useDispatch();
  const [gridData, setGridData] = useState([]);
  const [gridApi, setGridApi] = useState(null);

  useEffect(() => {
    // Spread both pending and complete checklist into gridData
    if (selectedObjectData) {
      let tempData = [];
      if (selectedObjectData) {
        selectedObjectData.pendingChecklists.forEach((item) => {
          tempData.push({
            ...item,
            status: "Pending",
            projectObjectId: selectedObjectData.projectObjectId,
            projectObject: selectedObjectData,
          });
        });
        selectedObjectData.checklists?.forEach((item) => {
          tempData.push({
            ...item.projectChecklist,
            // name: item.projectChecklist.name,
            status: "Complete",
            projectObjectId: selectedObjectData.projectObjectId,
            projectObject: selectedObjectData,
          });
        });
        setGridData(tempData);
      }
    }
  }, [selectedObjectData]);

  const handleButtonClick = (checklist) => {
    dispatch(
      updateGlobalState({
        value: checklist,
        stateName: SELECTED_CHECKLIST,
      })
    );
    dispatch(
      updateNavigationState({
        value: "Checklists",
        stateName: SELECTED_ICON,
      })
    );
  };

  const idCellRenderer = (params) => {
    return (
      <button
        className="btn btn-primary btn-sm"
        onClick={() => handleButtonClick(params.data)}
      >
        {/* If status is pending display record otherwise display view */}
        {params.data.status === "Pending" ? "Record" : "View"}
      </button>
    );
  };

  const columns = [
    {
      headerName: "ID",
      field: "id",
      minWidth: 100,
      maxWidth: 100,
      cellRenderer: idCellRenderer,
    },
    { headerName: "Name", field: "name" },
    { headerName: "Status", field: "status" },
  ];

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  return (
    <div>
      <div style={{ height: 400, width: "100%" }}>
        <AgGridReact
          theme={agGridTheme}
          rowData={gridData}
          columnDefs={columns}
          onGridReady={onGridReady}
          gridOptions={agGridOptionsNone}
        />
      </div>
    </div>
  );
};

export default ChecklistSidePanel;
